<ng-container *ngIf="!env.USE_TAILWIND">
    <div class="ticket">
        <div class="confirmation-mail">
            <div class="confirmation-mail-area">
                <div class="confirmation-mail-area__icon">
                    <ridango-ui-icons name="emailSent"></ridango-ui-icons>
                </div>
                <div *ngIf="formerCustomerFirstVisit">
                    <div class="confirmation-mail-area__title">{{ firstVisitTitle | translate }}</div>
                    <div class="confirmation-mail-area__description">
                        <p>
                            <span>{{ firstVisitDescription | translate }}</span>
                            <span class="user-email"> {{ email }}</span>
                        </p>
                    </div>
                </div>
                <div *ngIf="!formerCustomerFirstVisit">
                    <div class="confirmation-mail-area__title">{{ title | translate }}</div>
                    <div class="confirmation-mail-area__description">
                        <p>
                            <span>{{ description | translate }}</span>
                            <span class="user-email"> {{ email }}</span>
                        </p>
                    </div>
                </div>

                <div class="flex-center">
                    <ng-content></ng-content>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="env.USE_TAILWIND">
    <div class="overflow-hidden dark:bg-contrast-black">
        <div class="max-content max-content--secondary md:grid md:min-h-[73vh] md:grid-cols-[1fr_1.5fr] lg:grid-cols-2">
            <aside
                class="relative hidden min-h-[20vh] items-center py-5 before:absolute before:-left-[100vw] before:-right-[100vw] before:bottom-0 before:top-0 before:-z-10 before:bg-[#F8F8F8] before:content-[''] md:flex md:h-auto md:pr-8 md:before:right-0">
                <div class="word-break md:w-full lg:max-w-[26rem]">
                    <h1 class="mb-5 text-2xl md:text-[2.5rem]">
                        {{ 'STARTED_WITH_ACCOUNT_TITLE' | translate }}
                    </h1>

                    <p class="mb-5 md:max-w-xl">{{ 'STARTED_WITH_ACCOUNT_DESCRIPTION' | translate }}</p>
                </div>

                <div
                    class="flex h-full items-center md:invisible md:w-auto lg:visible lg:w-[56%]"
                    *ngIf="env.THEME_NAME === themeFeature.PILET">
                    <img
                        class="absolute -right-[2rem] z-10 h-[62vh]"
                        alt=""
                        src="./assets/img/ridango-logo-shape.svg" />
                </div>
            </aside>

            <section
                class="relative flex min-h-[60vh] max-w-2xl items-center justify-items-center bg-white py-5 before:absolute before:-left-[100vw] before:-right-[100vw] before:bottom-0 before:top-0 before:-z-10 before:bg-white before:content-[''] md:h-auto md:pl-8 md:before:left-0 lg:pl-20">
                <div class="confirmation-mail-area mt-0">
                    <div class="flex justify-center" aria-hidden="true">
                        <ridango-ui-icons class="h-auto" name="emailSent"></ridango-ui-icons>
                    </div>

                    <div *ngIf="formerCustomerFirstVisit">
                        <div class="confirmation-mail-area__title">{{ firstVisitTitle | translate }}</div>
                        <div class="confirmation-mail-area__description">
                            <p>
                                <span>{{ firstVisitDescription | translate }}</span>
                                <span class="user-email"> {{ email }}</span>
                            </p>
                        </div>
                    </div>

                    <div *ngIf="!formerCustomerFirstVisit">
                        <div class="confirmation-mail-area__title">{{ title | translate }}</div>
                        <div class="confirmation-mail-area__description">
                            <p>
                                <span>{{ description | translate }}</span>
                                <span class="user-email"> {{ email }}</span>
                            </p>
                        </div>
                    </div>

                    <div class="flex-center">
                        <ng-content></ng-content>
                    </div>
                </div>
            </section>
        </div>
    </div>
</ng-container>
